export function getProbabilityMeta(value) {
  if (value == null) return { label: "Nicht gesetzt", tone: "muted" };
  if (value <= 0) return { label: "0 %", tone: "destructive" };
  if (value >= 70) return { label: `${value} %`, tone: "success" };
  if (value >= 40) return { label: `${value} %`, tone: "info" };
  return { label: `${value} %`, tone: "warning" };
}

